import { useMetabaseUrl } from "model";
import { useUIStore } from "stores";
import { MetabaseIframe } from "./MetabaseIframe";

export function AccessibleFarmsInsights() {
  const selectedAccessibleFarmerDashboard = useUIStore(
    (state) => state.selectedAccessibleFarmerDashboard
  );

  const selectedAccessibleFarmer = useUIStore(
    (state) => state.selectedAccessibleFarmer
  );

  const params: { [name: string]: string } = {
    userFilter: selectedAccessibleFarmer?.guid ?? "",
  };

  const enabled =
    !!selectedAccessibleFarmerDashboard?.guid &&
    !!selectedAccessibleFarmer?.guid;

  const { data } = useMetabaseUrl(
    selectedAccessibleFarmerDashboard?.guid ?? null,
    params,
    enabled
  );

  const metabaseUrl = data?.url ?? "";

  return <MetabaseIframe metabaseUrl={metabaseUrl}></MetabaseIframe>;
}
